import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=5ef26642&"
import script from "./MainLayout.vue?vue&type=script&lang=ts&"
export * from "./MainLayout.vue?vue&type=script&lang=ts&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ef26642')) {
      api.createRecord('5ef26642', component.options)
    } else {
      api.reload('5ef26642', component.options)
    }
    module.hot.accept("./MainLayout.vue?vue&type=template&id=5ef26642&", function () {
      api.rerender('5ef26642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/admin/MainLayout.vue"
export default component.exports